export default __webpack_public_path__ + "media/images/images/flags/wv-4023919778b2836478a242282ac54b36.png";